import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {AdminViewComponent} from './admin-view/admin-view.component';

const routes: Routes = [
  {path: '', component: AdminViewComponent},
  // { path: 'seed', component: RcAdminSeedComponent },
  // { path: 'edit-customer', component: EditCustomerComponent },
  // { path: 'edit-property', component: EditPropertyComponent },
  {
    path: 'users-list',
    loadComponent: () => import('./users/user-list/user-list.component').then((m) => m.UserListComponent),
  },
  {
    path: 'clients-list',
    loadComponent: () =>
      import('./clients/components/client-list/client-list.component').then((m) => m.ClientListComponent),
  },
  {
    path: 'product-list',
    loadComponent: () =>
      import('./products/components/product-list/product-list.component').then((m) => m.ProductListComponent),
  },
  {
    path: 'service-list',
    loadComponent: () =>
      import('./service-products/components/service-list/service-list.component').then((m) => m.ServiceListComponent),
  },
  {
    path: 'edit-client/:editingStatus',
    loadComponent: () =>
      import('./clients/components/edit-client/edit-client.component').then((m) => m.EditClientComponent),
  },
  {
    path: 'edit-user/:editingStatus',
    loadComponent: () => import('./users/edit-user/edit-user.component').then((m) => m.EditUserComponent),
  },
  {
    path: 'edit-product/:editingStatus',
    loadComponent: () =>
      import('./products/components/edit-product/edit-product.component').then((m) => m.EditProductComponent),
  },
  {
    path: 'edit-service/:editingStatus',
    loadComponent: () =>
      import('./service-products/components/edit-service/edit-service.component').then((m) => m.EditServiceComponent),
  },
  // {
  //   path: 'edit-sport-bet/:editingStatus',
  //   loadComponent: () => import('./components/edit-sport-bet/edit-sport-bet.component').then(m => m.EditSportBetComponent)
  // },
  // {
  //   path: 'edit-wager-source/:editingStatus',
  //   loadComponent: () => import('./components/edit-wager-source/edit-wager-source.component').then(m => m.EditWagerSourceComponent)
  // }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
